export default {
    Responsible: { id: 'employeeprofile_1', defaultMessage: 'Responsible' },
    Assistant: { id: 'employeeprofile_2', defaultMessage: 'Assistant' },
    AssistantBackup: { id: 'employeeprofile_3', defaultMessage: 'Assistant backup' },
    Associate: { id: 'employeeprofile_4', defaultMessage: 'Associate' },
    BillingUser: { id: 'employeeprofile_5', defaultMessage: 'Billing user' },
    SeniorUser: { id: 'employeeprofile_6', defaultMessage: 'Senior user' },
    FilterResponsible: { id: 'employeeprofile_1', defaultMessage: 'Responsible' },
    FilterAssistant: { id: 'employeeprofile_2', defaultMessage: 'Assistant' },
    FilterAssistantBackup: { id: 'employeeprofile_3', defaultMessage: 'Assistant backup' },
    FilterAssociate: { id: 'employeeprofile_4', defaultMessage: 'Associate' },
    FilterBillingUser: { id: 'employeeprofile_5', defaultMessage: 'Billing user' },
    FilterSeniorUser: { id: 'employeeprofile_6', defaultMessage: 'Senior user' },
};
